export enum ButtonType {
    Light = "light",
    Dark = "dark"
}